/** Exportação CSV no dialeto que o Excel pt-BR abre sem assistente: ";" e BOM. */
export interface ColunaCsv<T> {
  cabecalho: string;
  valor: (linha: T) => string | number | null | undefined;
  /**
   * Força texto no Excel. Sem isso, identificador longo (pedido do ML tem 16
   * dígitos) vira número, sai como 2,00002E+15 e perde os dígitos depois do
   * 15º — não dá nem para formatar de volta. Sai como `="..."`.
   */
  texto?: boolean;
}

function escapar(bruto: string | number | null | undefined): string {
  if (bruto === null || bruto === undefined) return '';
  const texto = String(bruto);
  return /[";\n\r]/.test(texto) ? `"${texto.replace(/"/g, '""')}"` : texto;
}

export function montarCsv<T>(linhas: readonly T[], colunas: readonly ColunaCsv<T>[]): string {
  const cabecalho = colunas.map((c) => escapar(c.cabecalho)).join(';');
  const corpo = linhas.map((linha) =>
    colunas
      .map((c) => {
        const valor = c.valor(linha);
        if (!c.texto || valor === null || valor === undefined || valor === '') return escapar(valor);
        return escapar(`="${String(valor).replace(/"/g, '""')}"`);
      })
      .join(';'),
  );
  return [cabecalho, ...corpo].join('\r\n');
}

export function baixarCsv<T>(
  nomeArquivo: string,
  linhas: readonly T[],
  colunas: readonly ColunaCsv<T>[],
): void {
  const conteudo = `﻿${montarCsv(linhas, colunas)}`;
  const blob = new Blob([conteudo], { type: 'text/csv;charset=utf-8' });
  const url = URL.createObjectURL(blob);
  const link = document.createElement('a');
  link.href = url;
  link.download = nomeArquivo.endsWith('.csv') ? nomeArquivo : `${nomeArquivo}.csv`;
  document.body.append(link);
  link.click();
  link.remove();
  URL.revokeObjectURL(url);
}

export function carimboArquivo(): string {
  const d = new Date();
  const p = (n: number): string => String(n).padStart(2, '0');
  return `${d.getFullYear()}${p(d.getMonth() + 1)}${p(d.getDate())}-${p(d.getHours())}${p(d.getMinutes())}`;
}
